import React from 'react'
import Pt from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router'
import { Col, Panel, Row } from 'react-bootstrap'

import Icon from 'internal-components/src/components/Icon'
import { logout } from 'internal-components/src/redux/modules/authentication'

export class LogoutView extends React.Component {
  componentDidMount() {
    this.props.logout()

    /* eslint-disable */
    if (window._local && window._local.clearAll) {
      window._local.clearAll()
    }
    /* eslint-enable */
  }

  render() {
    return (
      <Row>
        <Col md={4} mdOffset={4}>
          <Panel>
            <Panel.Body>
              <div className="text-center m-b-md">
                <h3>Infinite Networks</h3>

                <Icon
                  name="hand-spock-o"
                  size="5x"
                  style={{ margin: '1em 0' }}
                />

                <p>
                  You have been logged out. <Link to="/login">Login</Link>.
                </p>
              </div>
            </Panel.Body>
          </Panel>
        </Col>
      </Row>
    )
  }
}

LogoutView.propTypes = {
  logout: Pt.func.isRequired,
}

export default connect(
  null,
  { logout },
)(LogoutView)



// WEBPACK FOOTER //
// ./src/views/Authentication/LogoutView.jsx